<i18n
  src="@/locales/views/organization/production/query_by_producers/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('list_processes')"
      :params="{
        organization_id: this.organization_id
      }"
    ></go-back-link>

    <template v-if="load_general_data">
      <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

      <div class="mt-6 px-4">
        <tabs-container v-model="option_tabs" :with_routing="true" />
      </div>

      <router-view
        v-if="show_content_tab"
        :summary="summary"
        :producers_summary="producers_summary"
        :crop_size_summary="crop_size_summary"
      ></router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/organization/requesters/production/query_by_producers/show_process.js";

export default {
  name: "OrgProductionQueryByProducerShowProcess",
  props: ["harvest_process_id", "organization_id"],
  data() {
    return {
      load_general_data: false,
      load_data_summary: false,
      load_data_producers: false,
      option_tabs: [],
      agro_exporter_process: {},
      producers: [],
      summary: {},
      producers_summary: [],
      crop_size_summary: []
    };
  },
  computed: {
    show_content_tab: function () {
      const route_name = this.$route.name;
      if (
        (route_name == this.routeName("show_process_summary") &&
          this.load_data_summary) ||
        (route_name == this.routeName("show_process_producers"))
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchHarvestProcess();
      await this.loadDataByTab();
      this.load_general_data = true;
    },
    loadDataByTab: async function () {
      if (this.option_tabs[0].current && !this.load_data_summary) {
        await this.fetchSummary();
        await this.fetchProducersSummary();
        await this.fetchCropSizeSummary();
        this.load_data_summary = true;
      }
      if (this.option_tabs[1].current && !this.load_data_producers) {
        // await this.fetchProducers();
      }
    },
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchProducers: async function () {
      let response = await Requester.fetchProducers(
        this.organization_id,
        this.harvest_process_id,
        this.current_page,
        this.rows_per_page
      );
      this.producers = response.data;
      this.load_data_producers = true;
    },
    fetchSummary: async function () {
      let response = await Requester.fetchSummary(
        this.organization_id,
        this.harvest_process_id
      );
      this.summary = response.data;
    },
    fetchProducersSummary: async function () {
      let response = await Requester.fetchProducersSummary(
        this.organization_id,
        this.harvest_process_id
      );
      this.producers_summary = response.data;
    },
    fetchCropSizeSummary: async function () {
      let response = await Requester.fetchCropSizeSummary(
        this.organization_id,
        this.harvest_process_id
      );
      this.crop_size_summary = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.tabs.summary"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_summary") },
          current: this.$route.name == this.routeName("show_process_summary")
        },
        {
          name: this.$t("labels.tabs.producers"),
          icon: "fa-solid fa-users",
          route: { name: this.routeName("show_process_producers") },
          current: this.$route.name == this.routeName("show_process_producers")
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => {
        this.fillOptions();
        this.fetchData();
      })
    );
  },
  watch: {
    option_tabs() {
      this.loadDataByTab();
    }
  }
};
</script>
